import { React } from 'react'
import Carousel from 'react-multi-carousel'
import 'react-multi-carousel/lib/styles.css'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { AdvancedImage } from "@cloudinary/react";
import { CloudinaryImage } from "@cloudinary/url-gen";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { format, quality } from "@cloudinary/url-gen/actions/delivery";
import { autoGravity } from "@cloudinary/url-gen/qualifiers/gravity";

const Categorys = () => {

    const { categorys } = useSelector((state) => state.home);

    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 3000 },
            items: 6
        },
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 6
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 4
        },
        mdtablet: {
            breakpoint: { max: 991, min: 464 },
            items: 4
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 3
        },
        smmobile: {
            breakpoint: { max: 640, min: 0 },
            items: 2
        },
        xsmobile: {
            breakpoint: { max: 440, min: 0 },
            items: 1
        }
    }
    const getOptimizedImageUrl = (publicId) => {
        const cldImage = new CloudinaryImage(publicId, { cloudName: "dapninft5" })
            .delivery(format("auto")) // Automatically select best format (WebP, AVIF, etc.)
            .delivery(quality("auto:low")) // Auto optimize quality (reduces file size significantly)
            .resize(fill().width(400).height(240).gravity(autoGravity())); // Resize with auto crop
        return cldImage;
    };

    return (
        <div className='w-[95%] mx-auto relative'>

            <Carousel
                autoPlay={true}
                infinite={true}
                arrows={true}
                responsive={responsive}
                transitionDuration={500}
            >
                {categorys.map((c, i) => (
                    <Link
                        to={`/products/search?category=${encodeURIComponent(c.name)}`}
                        className='h-[130px] border block  rounded-full bg-white mr-3 mb-2 drop-shadow-md'
                        key={i}
                    >
                        <div className='w-full  h-full relative p-2 '>
                            {/* <img className='object-cover w-full h-full rounded-full ' src={c.image} alt='image' /> */}
                            <AdvancedImage
                                className="object-cover w-full h-full rounded-full "
                                cldImg={getOptimizedImageUrl(
                                    c.image
                                        .split("/")
                                        .slice(-2)
                                        .join("/")
                                        .replace(/\.[^.]+$/, "")
                                )}
                                alt="image"
                            />
                            <div className='absolute bottom-6 w-full mx-auto font-bold left-0 flex justify-center items-center'>
                                <span className='py-[2px] px-6 rounded-lg bg-[#3330305d] text-white'>{c.name}</span>
                            </div>
                        </div>
                    </Link>
                ))}
            </Carousel>
        </div>
    )
}

export default Categorys